// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-02b007f5]{font-family:Vazir,serif!important;white-space:break-spaces;overflow:hidden}.link-tag[data-v-02b007f5],.link-tag .v-icon[data-v-02b007f5]{color:#0985d2;cursor:pointer}.link-tag[data-v-02b007f5]:hover,.link-tag:hover .v-icon[data-v-02b007f5]{color:#33a9f1}", ""]);
// Exports
module.exports = exports;
